
import React, { lazy } from 'react'

import { Grid } from '@mui/material'

import DownloadAppBanner from './DownloadAppBanner'
import HowItWorks from './HowItWorks'
import LandingFooter from './LandingFooter'
import LandingPageHeader from './LandingPageHeader'
import NewVenuesBanner from './NewVenuesBanner'
import PopularVenuesBanner from './PopularVenuesBanner'
import ThreeRowBanner from './ThreeRowBanner'

const Footer = lazy(() => import('../../components/Footer'))

export default function LandingPage () {
  return (
      <>
        <LandingPageHeader />

        <Grid>
          <Grid xl={12} xs={12} item>
          <NewVenuesBanner />
          <HowItWorks />
          <PopularVenuesBanner />
          <DownloadAppBanner />
          <ThreeRowBanner />
          <LandingFooter />
          </Grid>
        </Grid>

        <Footer />
      </>
  )
}
